'use es6';

export const getFlash = (state, props) => state.flash[props.key];